import React from 'react';
import PropTypes from 'prop-types';

// Misc

// Redux
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { formName } from '../../../../constants/forms';
import { getAvailableTextureById } from '../../../../ducks/availableTextures';

// Import Components
import DetailEditFormStyle from './style';
import { ReduxFormFileUploader, ReduxFormInput } from '../../../Shared/reduxForm';
import { Button } from '../../../Shared';

DetailEditForm.propTypes = {
  // from parent component
  onSubmit: PropTypes.func,
  disabledSubmit: PropTypes.bool,
};

function DetailEditForm({
  initialValues, handleSubmit, onSubmit, pristine, submitting, invalid,
}) {
  return (
    <DetailEditFormStyle>
      <form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        className="available-textures__form"
      >
        <div className="available-textures__column preview">
          <ReduxFormFileUploader
            name="file"
            fileUrl={initialValues.file}
            formName={formName.availableTexturesEditForm}
            width="100px"
            height="100px"
          />
        </div>
        <div className="available-textures__column fields">
          <ReduxFormInput
            name="name"
            label="Texture name"
          />
        </div>
        <div className="available-textures__button">
          <Button
            size="large"
            type="submit"
            width={200}
            disabled={pristine || submitting || invalid}
          >
            Save
          </Button>
        </div>
      </form>
    </DetailEditFormStyle>
  );
}

// Enhancer
const mapStateToProps = (state) => ({
  initialValues: {
    name: getAvailableTextureById(state).label,
    file: getAvailableTextureById(state).image_url && getAvailableTextureById(state).image_url.url,
  },
});

const enhancer = compose(
  connect(mapStateToProps),
  reduxForm({
    form: formName.availableTexturesEditForm,
  })
);

export default enhancer(DetailEditForm);
